import DehumidifiersInsiderLogo from './logo'
import {dehumidifiersInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'dehumidifiersinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Dehumidifiers Insider',
  logo: <DehumidifiersInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/dehumidifiersinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-PLLCKKLMC3',
    camelCaseUrl: 'DehumidifiersInsider.com',
    title: (category: string, count: string) =>
      `Dehumidifiers Insider | Top ${count} Pro Insider Choices for ${category}`,
    description: (_category?: string, count?: string) =>
      `Say goodbye to dampness. Dehumidifier Insider reveals the top ${count} models for a comfortable, dry home. Control humidity with our expert picks.`,
    styles: dehumidifiersInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
